import { useEffect, useState } from "react";
import moment from "moment";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import AddWfhModal from "./AddWfhModal";

export default function AdminWfhRequest() {
  const [modalOpen, setModalOpen] = useState(false);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 1,
    tableLoader: false,
    wfhList: [],
    status: ""
  });

  const getWfhRequests = async () => {
    try {
      setPageStates((prev) => ({ ...prev, tableLoader: true }));
      let query = `pageNumber=${pageStates.currentPage}&pageSize=${pageStates.pageSize}`;
      if (pageStates.status) query += `&status=${pageStates.status}`;

      const res = await callApi(`${apiUrl.get_wfh}${query}`);
      const rawRows = res?.data?.wfhRequest || res?.data?.rows || [];
      const formattedData = rawRows.map((item) => ({
        ...item,
        empName: item?.user?.name || "--",
        startDateFormatted: item?.startDate ? moment(item.startDate).format("DD/MM/YYYY") : "--",
        endDateFormatted: item?.endDate ? moment(item.endDate).format("DD/MM/YYYY") : "--",
        wfhStatus: item?.status
      }));

      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
        wfhList: formattedData,
        count: res?.data?.count || formattedData.length,
        totalPages: res?.data?.totalPages || 1
      }));
    } catch (err) {
      setPageStates((prev) => ({ ...prev, tableLoader: false }));
      toast.error(err?.message || "Error fetching WFH requests");
    }
  };

  useEffect(() => {
    getWfhRequests();
  }, [pageStates.currentPage, pageStates.pageSize, pageStates.status]);

  const handleStatusChange = async (wfhId, status) => {
    try {
      const res = await callApi(apiUrl.update_wfh_status, { method: "POST", data: { wfhRequestId: wfhId, status } });
      if (res?.statuscode === 200 || res?.status === true) {
        toast.success(res?.message || "WFH Status Updated");
        getWfhRequests();
      } else {
        toast.error(res?.message || "Failed to update status");
      }
    } catch (err) {
      toast.error(err?.message || "Error updating status");
    }
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "empName", label: "Employee Name" },
    { value: "startDateFormatted", label: "From" },
    { value: "endDateFormatted", label: "To" },
    { value: "reason", label: "Reason" },
    { value: "wfhStatus", label: "Status" }
  ];

  const ActionData = [
    {
      label: "Approve",
      className: "btn btn-sm btn-success me-1",
      title: "Approve",
      clickHandler: (row) => handleStatusChange(row.id, 1)
    },
    {
      label: "Reject",
      className: "btn btn-sm btn-danger",
      title: "Reject",
      clickHandler: (row) => handleStatusChange(row.id, 2)
    }
  ];

  return (
    <div className="content p-4">
      <MainHeading
        title="Work From Home (WFH) Requests"
        buttonText="Apply WFH"
        clickHandler={() => setModalOpen(true)}
      />

      <div className="card mt-4">
        <div className="card-body">
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates.wfhList}
            ActionData={ActionData}
            currentPage={pageStates.currentPage}
            PageChangeHandler={(page) => setPageStates((prev) => ({ ...prev, currentPage: page }))}
            isLoading={pageStates.tableLoader}
            totalPages={pageStates.totalPages}
            count={pageStates.count}
            handleChangePageSize={(size) => setPageStates((prev) => ({ ...prev, pageSize: size }))}
            pageSize={pageStates.pageSize}
          />
        </div>
      </div>

      <AddWfhModal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} refreshData={getWfhRequests} />
    </div>
  );
}
